import { render, staticRenderFns } from "./GlobalConfig.vue?vue&type=template&id=3a27573d"
import script from "./GlobalConfig.vue?vue&type=script&lang=js"
export * from "./GlobalConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports